// extracted by mini-css-extract-plugin
export var alertIcon = "_sp-0";